@file:OptIn(ExperimentalTime::class)

package com.macrofocus.eflux.network.risk

import kotlin.time.ExperimentalTime
import kotlin.time.Instant

data class RiskTime(val riskTime: Instant,
                    val lightning_hit: Long,
                    val lightning_activity: Long,
                    val lightning_expected: Long,
                    val flooding: Long,
                    val mudslide: Long,
                    val wind_gusts: Long,
                    val temperature: Long,
                    val probability: Double?,
                    val logicalBranchIds: String
    ) {
}